
import { StudentLayout } from "@/components/student/layout";
import { MyNotesTab } from "@/components/student/MyNotesTab";

const MyNotes = () => {
  return (
    <StudentLayout
      title="My Notes"
      description="View and manage all your course notes"
    >
      <div className="container max-w-screen-lg mx-auto">
        <MyNotesTab />
      </div>
    </StudentLayout>
  );
};

export default MyNotes;
